"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// THIS FILE IS GENERATED BY CODE GENERATOR. DO NOT CHANGE MANUALLY.
/* tslint:disable */
/* eslint-disable */
var types_1 = require("./types");
var GetAlbumPhotos = /** @class */ (function () {
    function GetAlbumPhotos(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/albums/" + pathParameter.albumId + "/photos";
    }
    return GetAlbumPhotos;
}());
exports.GetAlbumPhotos = GetAlbumPhotos;
var CertifyMember = /** @class */ (function () {
    function CertifyMember(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/certify";
    }
    return CertifyMember;
}());
exports.CertifyMember = CertifyMember;
var Login = /** @class */ (function () {
    function Login(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/login";
    }
    return Login;
}());
exports.Login = Login;
var GetLoginProfile = /** @class */ (function () {
    function GetLoginProfile(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/login_profile";
    }
    return GetLoginProfile;
}());
exports.GetLoginProfile = GetLoginProfile;
var Logout = /** @class */ (function () {
    function Logout(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/logout";
    }
    return Logout;
}());
exports.Logout = Logout;
var PasswordForgot = /** @class */ (function () {
    function PasswordForgot(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/password_forgot";
    }
    return PasswordForgot;
}());
exports.PasswordForgot = PasswordForgot;
var PasswordReset = /** @class */ (function () {
    function PasswordReset(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/password_reset";
    }
    return PasswordReset;
}());
exports.PasswordReset = PasswordReset;
var Signup = /** @class */ (function () {
    function Signup(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/signup";
    }
    return Signup;
}());
exports.Signup = Signup;
var TokenRefresh = /** @class */ (function () {
    function TokenRefresh(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/refresh";
    }
    return TokenRefresh;
}());
exports.TokenRefresh = TokenRefresh;
var VerifyGroupInvitationToken = /** @class */ (function () {
    function VerifyGroupInvitationToken(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/verify_group_invitation_token";
    }
    return VerifyGroupInvitationToken;
}());
exports.VerifyGroupInvitationToken = VerifyGroupInvitationToken;
var VerifyPasswordResetToken = /** @class */ (function () {
    function VerifyPasswordResetToken(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/verify_password_reset_token";
    }
    return VerifyPasswordResetToken;
}());
exports.VerifyPasswordResetToken = VerifyPasswordResetToken;
var VerifySignupStore = /** @class */ (function () {
    function VerifySignupStore(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/verify_signup_store";
    }
    return VerifySignupStore;
}());
exports.VerifySignupStore = VerifySignupStore;
var Signoff = /** @class */ (function () {
    function Signoff(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/signoff";
    }
    return Signoff;
}());
exports.Signoff = Signoff;
var UchinokoDetect = /** @class */ (function () {
    function UchinokoDetect(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/c4/detect";
    }
    return UchinokoDetect;
}());
exports.UchinokoDetect = UchinokoDetect;
var EventUchinokoSearch = /** @class */ (function () {
    function EventUchinokoSearch(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/c4/events/" + pathParameter.eventId + "/photos/uchinoko_search";
    }
    return EventUchinokoSearch;
}());
exports.EventUchinokoSearch = EventUchinokoSearch;
var EventCartQuerySearch = /** @class */ (function () {
    function EventCartQuerySearch(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/c4/events/" + pathParameter.eventId + "/photos/cart_query_search";
    }
    return EventCartQuerySearch;
}());
exports.EventCartQuerySearch = EventCartQuerySearch;
var EventCartQueryPost = /** @class */ (function () {
    function EventCartQueryPost(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/c4/events/" + pathParameter.eventId + "/cart_query";
    }
    return EventCartQueryPost;
}());
exports.EventCartQueryPost = EventCartQueryPost;
var EventCartQueryDelete = /** @class */ (function () {
    function EventCartQueryDelete(args) {
        this.method = types_1.HTTPMethod["delete"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/c4/events/" + pathParameter.eventId + "/cart_query";
    }
    return EventCartQueryDelete;
}());
exports.EventCartQueryDelete = EventCartQueryDelete;
var GetCart = /** @class */ (function () {
    function GetCart(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/cart";
    }
    return GetCart;
}());
exports.GetCart = GetCart;
var GetCartSummary = /** @class */ (function () {
    function GetCartSummary(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/cart/summary";
    }
    return GetCartSummary;
}());
exports.GetCartSummary = GetCartSummary;
var GetCartItems = /** @class */ (function () {
    function GetCartItems(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/cart/items";
    }
    return GetCartItems;
}());
exports.GetCartItems = GetCartItems;
var AddCartItem = /** @class */ (function () {
    function AddCartItem(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/cart/items";
    }
    return AddCartItem;
}());
exports.AddCartItem = AddCartItem;
var DeleteCartItems = /** @class */ (function () {
    function DeleteCartItems(args) {
        this.method = types_1.HTTPMethod["delete"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/cart/items";
    }
    return DeleteCartItems;
}());
exports.DeleteCartItems = DeleteCartItems;
var GetCartItem = /** @class */ (function () {
    function GetCartItem(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/cart/items/" + pathParameter.cartItemId;
    }
    return GetCartItem;
}());
exports.GetCartItem = GetCartItem;
var UpdateCartItem = /** @class */ (function () {
    function UpdateCartItem(args) {
        this.method = types_1.HTTPMethod["put"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/cart/items/" + pathParameter.cartItemId;
    }
    return UpdateCartItem;
}());
exports.UpdateCartItem = UpdateCartItem;
var DeleteCartItem = /** @class */ (function () {
    function DeleteCartItem(args) {
        this.method = types_1.HTTPMethod["delete"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/cart/items/" + pathParameter.cartItemId;
    }
    return DeleteCartItem;
}());
exports.DeleteCartItem = DeleteCartItem;
var AddCartItemLogo = /** @class */ (function () {
    function AddCartItemLogo(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/cart/items/" + pathParameter.cartItemId + "/logo";
    }
    return AddCartItemLogo;
}());
exports.AddCartItemLogo = AddCartItemLogo;
var DeleteCartItemLogo = /** @class */ (function () {
    function DeleteCartItemLogo(args) {
        this.method = types_1.HTTPMethod["delete"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/cart/items/" + pathParameter.cartItemId + "/logo";
    }
    return DeleteCartItemLogo;
}());
exports.DeleteCartItemLogo = DeleteCartItemLogo;
var AddCartItemCaption = /** @class */ (function () {
    function AddCartItemCaption(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/cart/items/" + pathParameter.cartItemId + "/caption";
    }
    return AddCartItemCaption;
}());
exports.AddCartItemCaption = AddCartItemCaption;
var DeleteCartItemCaption = /** @class */ (function () {
    function DeleteCartItemCaption(args) {
        this.method = types_1.HTTPMethod["delete"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/cart/items/" + pathParameter.cartItemId + "/caption";
    }
    return DeleteCartItemCaption;
}());
exports.DeleteCartItemCaption = DeleteCartItemCaption;
var GetCartEvents = /** @class */ (function () {
    function GetCartEvents(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/cart/events";
    }
    return GetCartEvents;
}());
exports.GetCartEvents = GetCartEvents;
var AddCaptions = /** @class */ (function () {
    function AddCaptions(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/cart/items/caption";
    }
    return AddCaptions;
}());
exports.AddCaptions = AddCaptions;
var ResizeCartItems = /** @class */ (function () {
    function ResizeCartItems(args) {
        this.method = types_1.HTTPMethod["put"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/cart/items/resize";
    }
    return ResizeCartItems;
}());
exports.ResizeCartItems = ResizeCartItems;
var AddCartItemsOtherArticle = /** @class */ (function () {
    function AddCartItemsOtherArticle(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/cart/items/other_article";
    }
    return AddCartItemsOtherArticle;
}());
exports.AddCartItemsOtherArticle = AddCartItemsOtherArticle;
var GetCartArticles = /** @class */ (function () {
    function GetCartArticles(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/cart/articles";
    }
    return GetCartArticles;
}());
exports.GetCartArticles = GetCartArticles;
var GetCartPhotosByArticle = /** @class */ (function () {
    function GetCartPhotosByArticle(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/cart/articles/" + pathParameter.article_id + "/photos";
    }
    return GetCartPhotosByArticle;
}());
exports.GetCartPhotosByArticle = GetCartPhotosByArticle;
var GetCampaignStatus = /** @class */ (function () {
    function GetCampaignStatus(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/campaigns/status";
    }
    return GetCampaignStatus;
}());
exports.GetCampaignStatus = GetCampaignStatus;
var SubmitCampaign = /** @class */ (function () {
    function SubmitCampaign(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/campaigns/submit";
    }
    return SubmitCampaign;
}());
exports.SubmitCampaign = SubmitCampaign;
var GetCreditCardInfo = /** @class */ (function () {
    function GetCreditCardInfo(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/credit";
    }
    return GetCreditCardInfo;
}());
exports.GetCreditCardInfo = GetCreditCardInfo;
var PostCreditCardInfo = /** @class */ (function () {
    function PostCreditCardInfo(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/credit";
    }
    return PostCreditCardInfo;
}());
exports.PostCreditCardInfo = PostCreditCardInfo;
var DeleteCreditCardInfo = /** @class */ (function () {
    function DeleteCreditCardInfo(args) {
        this.method = types_1.HTTPMethod["delete"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/credit/delete_all";
    }
    return DeleteCreditCardInfo;
}());
exports.DeleteCreditCardInfo = DeleteCreditCardInfo;
var StartDigibookImageEdit = /** @class */ (function () {
    function StartDigibookImageEdit(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/digibook/start";
    }
    return StartDigibookImageEdit;
}());
exports.StartDigibookImageEdit = StartDigibookImageEdit;
var ResetDigibookImageEdit = /** @class */ (function () {
    function ResetDigibookImageEdit(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/digibook/reset";
    }
    return ResetDigibookImageEdit;
}());
exports.ResetDigibookImageEdit = ResetDigibookImageEdit;
var GetEvent = /** @class */ (function () {
    function GetEvent(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/events/" + pathParameter.eventId;
    }
    return GetEvent;
}());
exports.GetEvent = GetEvent;
var GetEventAlbums = /** @class */ (function () {
    function GetEventAlbums(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/events/" + pathParameter.eventId + "/albums";
    }
    return GetEventAlbums;
}());
exports.GetEventAlbums = GetEventAlbums;
var GetEventPhotos = /** @class */ (function () {
    function GetEventPhotos(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/events/" + pathParameter.eventId + "/photos";
    }
    return GetEventPhotos;
}());
exports.GetEventPhotos = GetEventPhotos;
var GetEventPhotoPrices = /** @class */ (function () {
    function GetEventPhotoPrices(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/events/" + pathParameter.eventId + "/photos/prices";
    }
    return GetEventPhotoPrices;
}());
exports.GetEventPhotoPrices = GetEventPhotoPrices;
var SearchEventPhotos = /** @class */ (function () {
    function SearchEventPhotos(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/events/" + pathParameter.eventId + "/photos/search";
    }
    return SearchEventPhotos;
}());
exports.SearchEventPhotos = SearchEventPhotos;
var UnlockEvent = /** @class */ (function () {
    function UnlockEvent(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/events/" + pathParameter.eventId + "/unlock";
    }
    return UnlockEvent;
}());
exports.UnlockEvent = UnlockEvent;
var GetEventCampaigns = /** @class */ (function () {
    function GetEventCampaigns(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/events/" + pathParameter.eventId + "/campaigns";
    }
    return GetEventCampaigns;
}());
exports.GetEventCampaigns = GetEventCampaigns;
var GetEventThumbnails = /** @class */ (function () {
    function GetEventThumbnails(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/events/thumbnails";
    }
    return GetEventThumbnails;
}());
exports.GetEventThumbnails = GetEventThumbnails;
var GetCartQueryStatus = /** @class */ (function () {
    function GetCartQueryStatus(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/events/" + pathParameter.eventId + "/cart_query_status";
    }
    return GetCartQueryStatus;
}());
exports.GetCartQueryStatus = GetCartQueryStatus;
var GetGroups = /** @class */ (function () {
    function GetGroups(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families";
    }
    return GetGroups;
}());
exports.GetGroups = GetGroups;
var PostGroup = /** @class */ (function () {
    function PostGroup(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families";
    }
    return PostGroup;
}());
exports.PostGroup = PostGroup;
var GetGroup = /** @class */ (function () {
    function GetGroup(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId;
    }
    return GetGroup;
}());
exports.GetGroup = GetGroup;
var UpdateGroup = /** @class */ (function () {
    function UpdateGroup(args) {
        this.method = types_1.HTTPMethod["put"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId;
    }
    return UpdateGroup;
}());
exports.UpdateGroup = UpdateGroup;
var DeleteGroup = /** @class */ (function () {
    function DeleteGroup(args) {
        this.method = types_1.HTTPMethod["delete"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId;
    }
    return DeleteGroup;
}());
exports.DeleteGroup = DeleteGroup;
var GetGroupChildren = /** @class */ (function () {
    function GetGroupChildren(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/children";
    }
    return GetGroupChildren;
}());
exports.GetGroupChildren = GetGroupChildren;
var CreateGroupChild = /** @class */ (function () {
    function CreateGroupChild(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/children";
    }
    return CreateGroupChild;
}());
exports.CreateGroupChild = CreateGroupChild;
var GetGroupChild = /** @class */ (function () {
    function GetGroupChild(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/children/{childId}";
    }
    return GetGroupChild;
}());
exports.GetGroupChild = GetGroupChild;
var UpdateGroupChild = /** @class */ (function () {
    function UpdateGroupChild(args) {
        this.method = types_1.HTTPMethod["put"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/children/{childId}";
    }
    return UpdateGroupChild;
}());
exports.UpdateGroupChild = UpdateGroupChild;
var DeleteGroupChild = /** @class */ (function () {
    function DeleteGroupChild(args) {
        this.method = types_1.HTTPMethod["delete"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/children/{childId}";
    }
    return DeleteGroupChild;
}());
exports.DeleteGroupChild = DeleteGroupChild;
var DeleteGroupChildImage = /** @class */ (function () {
    function DeleteGroupChildImage(args) {
        this.method = types_1.HTTPMethod["delete"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/children/{childId}/profile_image";
    }
    return DeleteGroupChildImage;
}());
exports.DeleteGroupChildImage = DeleteGroupChildImage;
var RegisterSchools = /** @class */ (function () {
    function RegisterSchools(args) {
        this.method = types_1.HTTPMethod["put"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/children/{childId}/schools";
    }
    return RegisterSchools;
}());
exports.RegisterSchools = RegisterSchools;
var GetGroupSchools = /** @class */ (function () {
    function GetGroupSchools(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/schools";
    }
    return GetGroupSchools;
}());
exports.GetGroupSchools = GetGroupSchools;
var PostGroupSchool = /** @class */ (function () {
    function PostGroupSchool(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/schools";
    }
    return PostGroupSchool;
}());
exports.PostGroupSchool = PostGroupSchool;
var GetGroupSchoolsEvents = /** @class */ (function () {
    function GetGroupSchoolsEvents(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/schools/{schoolId}/events";
    }
    return GetGroupSchoolsEvents;
}());
exports.GetGroupSchoolsEvents = GetGroupSchoolsEvents;
var GetGroupSetting = /** @class */ (function () {
    function GetGroupSetting(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/setting";
    }
    return GetGroupSetting;
}());
exports.GetGroupSetting = GetGroupSetting;
var UpdateGroupSetting = /** @class */ (function () {
    function UpdateGroupSetting(args) {
        this.method = types_1.HTTPMethod["put"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/setting";
    }
    return UpdateGroupSetting;
}());
exports.UpdateGroupSetting = UpdateGroupSetting;
var GetGroupMembers = /** @class */ (function () {
    function GetGroupMembers(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/members";
    }
    return GetGroupMembers;
}());
exports.GetGroupMembers = GetGroupMembers;
var GetGroupMember = /** @class */ (function () {
    function GetGroupMember(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/members/{memberId}";
    }
    return GetGroupMember;
}());
exports.GetGroupMember = GetGroupMember;
var PutGroupMember = /** @class */ (function () {
    function PutGroupMember(args) {
        this.method = types_1.HTTPMethod["put"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/members/{memberId}";
    }
    return PutGroupMember;
}());
exports.PutGroupMember = PutGroupMember;
var DeleteGroupMember = /** @class */ (function () {
    function DeleteGroupMember(args) {
        this.method = types_1.HTTPMethod["delete"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/members/{memberId}";
    }
    return DeleteGroupMember;
}());
exports.DeleteGroupMember = DeleteGroupMember;
var GetGroupEvents = /** @class */ (function () {
    function GetGroupEvents(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/events";
    }
    return GetGroupEvents;
}());
exports.GetGroupEvents = GetGroupEvents;
var GetGroupInvitation = /** @class */ (function () {
    function GetGroupInvitation(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/invitations/{groupInvitationId}";
    }
    return GetGroupInvitation;
}());
exports.GetGroupInvitation = GetGroupInvitation;
var DeleteGroupInvitation = /** @class */ (function () {
    function DeleteGroupInvitation(args) {
        this.method = types_1.HTTPMethod["delete"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/invitations/{groupInvitationId}";
    }
    return DeleteGroupInvitation;
}());
exports.DeleteGroupInvitation = DeleteGroupInvitation;
var ResendGroupInvitationEmail = /** @class */ (function () {
    function ResendGroupInvitationEmail(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/invitations/{groupInvitationId}/resend";
    }
    return ResendGroupInvitationEmail;
}());
exports.ResendGroupInvitationEmail = ResendGroupInvitationEmail;
var GetGroupInvitations = /** @class */ (function () {
    function GetGroupInvitations(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/invitations";
    }
    return GetGroupInvitations;
}());
exports.GetGroupInvitations = GetGroupInvitations;
var PostGroupInvitation = /** @class */ (function () {
    function PostGroupInvitation(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/families/" + pathParameter.groupId + "/invitations";
    }
    return PostGroupInvitation;
}());
exports.PostGroupInvitation = PostGroupInvitation;
var AcceptGroupInvitation = /** @class */ (function () {
    function AcceptGroupInvitation(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/family_accept_invitation";
    }
    return AcceptGroupInvitation;
}());
exports.AcceptGroupInvitation = AcceptGroupInvitation;
var SignupGroupMember = /** @class */ (function () {
    function SignupGroupMember(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/family_member_signup";
    }
    return SignupGroupMember;
}());
exports.SignupGroupMember = SignupGroupMember;
var VerifySchool = /** @class */ (function () {
    function VerifySchool(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/verify_school";
    }
    return VerifySchool;
}());
exports.VerifySchool = VerifySchool;
var PostInquiry = /** @class */ (function () {
    function PostInquiry(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/inquiries";
    }
    return PostInquiry;
}());
exports.PostInquiry = PostInquiry;
var UpdateProfile = /** @class */ (function () {
    function UpdateProfile(args) {
        this.method = types_1.HTTPMethod["put"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/profile";
    }
    return UpdateProfile;
}());
exports.UpdateProfile = UpdateProfile;
var GetMemberAddresses = /** @class */ (function () {
    function GetMemberAddresses(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/profile/addresses";
    }
    return GetMemberAddresses;
}());
exports.GetMemberAddresses = GetMemberAddresses;
var CreateMemberAddress = /** @class */ (function () {
    function CreateMemberAddress(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/profile/addresses";
    }
    return CreateMemberAddress;
}());
exports.CreateMemberAddress = CreateMemberAddress;
var GetMemberAddress = /** @class */ (function () {
    function GetMemberAddress(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/profile/addresses/" + pathParameter.memberAddressId;
    }
    return GetMemberAddress;
}());
exports.GetMemberAddress = GetMemberAddress;
var UpdateMemberAddress = /** @class */ (function () {
    function UpdateMemberAddress(args) {
        this.method = types_1.HTTPMethod["put"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/profile/addresses/" + pathParameter.memberAddressId;
    }
    return UpdateMemberAddress;
}());
exports.UpdateMemberAddress = UpdateMemberAddress;
var DeleteMemberAddress = /** @class */ (function () {
    function DeleteMemberAddress(args) {
        this.method = types_1.HTTPMethod["delete"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/profile/addresses/" + pathParameter.memberAddressId;
    }
    return DeleteMemberAddress;
}());
exports.DeleteMemberAddress = DeleteMemberAddress;
var RequestMemberEmailReset = /** @class */ (function () {
    function RequestMemberEmailReset(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/profile/email_reset_request";
    }
    return RequestMemberEmailReset;
}());
exports.RequestMemberEmailReset = RequestMemberEmailReset;
var ResetMemberEmail = /** @class */ (function () {
    function ResetMemberEmail(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/profile/email_reset";
    }
    return ResetMemberEmail;
}());
exports.ResetMemberEmail = ResetMemberEmail;
var UpdateMemberPassword = /** @class */ (function () {
    function UpdateMemberPassword(args) {
        this.method = types_1.HTTPMethod["put"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/profile/password";
    }
    return UpdateMemberPassword;
}());
exports.UpdateMemberPassword = UpdateMemberPassword;
var GetMemberSubscriptions = /** @class */ (function () {
    function GetMemberSubscriptions(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/profile/subscriptions";
    }
    return GetMemberSubscriptions;
}());
exports.GetMemberSubscriptions = GetMemberSubscriptions;
var PutMemberSubscriptions = /** @class */ (function () {
    function PutMemberSubscriptions(args) {
        this.method = types_1.HTTPMethod["put"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/profile/subscriptions";
    }
    return PutMemberSubscriptions;
}());
exports.PutMemberSubscriptions = PutMemberSubscriptions;
var GetServerTimestamp = /** @class */ (function () {
    function GetServerTimestamp(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/meta/time";
    }
    return GetServerTimestamp;
}());
exports.GetServerTimestamp = GetServerTimestamp;
var S3ImageUpload = /** @class */ (function () {
    function S3ImageUpload(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/s3/pre-signed-urls";
    }
    return S3ImageUpload;
}());
exports.S3ImageUpload = S3ImageUpload;
var GetPhoto = /** @class */ (function () {
    function GetPhoto(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/photos/" + pathParameter.photoId;
    }
    return GetPhoto;
}());
exports.GetPhoto = GetPhoto;
var GetPhotoBinary = /** @class */ (function () {
    function GetPhotoBinary(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/photos/" + pathParameter.photoId + "/binary";
    }
    return GetPhotoBinary;
}());
exports.GetPhotoBinary = GetPhotoBinary;
var GetPhotoPrices = /** @class */ (function () {
    function GetPhotoPrices(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/photos/" + pathParameter.photoId + "/prices";
    }
    return GetPhotoPrices;
}());
exports.GetPhotoPrices = GetPhotoPrices;
var PostPhotoRequestUnpublish = /** @class */ (function () {
    function PostPhotoRequestUnpublish(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/photos/" + pathParameter.photoId + "/request_unpublish";
    }
    return PostPhotoRequestUnpublish;
}());
exports.PostPhotoRequestUnpublish = PostPhotoRequestUnpublish;
var GetEventsBySchoolIds = /** @class */ (function () {
    function GetEventsBySchoolIds(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/schools/events";
    }
    return GetEventsBySchoolIds;
}());
exports.GetEventsBySchoolIds = GetEventsBySchoolIds;
var GetTpoints = /** @class */ (function () {
    function GetTpoints(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/tpoint/points";
    }
    return GetTpoints;
}());
exports.GetTpoints = GetTpoints;
var GetOrderSummaries = /** @class */ (function () {
    function GetOrderSummaries(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/orders";
    }
    return GetOrderSummaries;
}());
exports.GetOrderSummaries = GetOrderSummaries;
var CreateOrder = /** @class */ (function () {
    function CreateOrder(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/orders";
    }
    return CreateOrder;
}());
exports.CreateOrder = CreateOrder;
var GetOrderItemsByPhotos = /** @class */ (function () {
    function GetOrderItemsByPhotos(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/orders/items";
    }
    return GetOrderItemsByPhotos;
}());
exports.GetOrderItemsByPhotos = GetOrderItemsByPhotos;
var CreatePaypayOrder = /** @class */ (function () {
    function CreatePaypayOrder(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/orders/paypay";
    }
    return CreatePaypayOrder;
}());
exports.CreatePaypayOrder = CreatePaypayOrder;
var GetOrder = /** @class */ (function () {
    function GetOrder(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/orders/" + pathParameter.orderId;
    }
    return GetOrder;
}());
exports.GetOrder = GetOrder;
var GetOrderItems = /** @class */ (function () {
    function GetOrderItems(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/orders/" + pathParameter.orderId + "/items";
    }
    return GetOrderItems;
}());
exports.GetOrderItems = GetOrderItems;
var GetOrderItem = /** @class */ (function () {
    function GetOrderItem(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/orders/" + pathParameter.orderId + "/items/{orderItemId}";
    }
    return GetOrderItem;
}());
exports.GetOrderItem = GetOrderItem;
var VerifyCouponCode = /** @class */ (function () {
    function VerifyCouponCode(args) {
        this.method = types_1.HTTPMethod["post"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/verify_coupon_code";
    }
    return VerifyCouponCode;
}());
exports.VerifyCouponCode = VerifyCouponCode;
var GetPaypayOrderPaymentStatus = /** @class */ (function () {
    function GetPaypayOrderPaymentStatus(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/paypay/" + pathParameter.paypayOrderId + "/payment_status";
    }
    return GetPaypayOrderPaymentStatus;
}());
exports.GetPaypayOrderPaymentStatus = GetPaypayOrderPaymentStatus;
var GetPaypayOrderStatus = /** @class */ (function () {
    function GetPaypayOrderStatus(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/paypay/" + pathParameter.paypayOrderId + "/order_status";
    }
    return GetPaypayOrderStatus;
}());
exports.GetPaypayOrderStatus = GetPaypayOrderStatus;
var ZipCodeSearch = /** @class */ (function () {
    function ZipCodeSearch(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/yolp/zip_code_search";
    }
    return ZipCodeSearch;
}());
exports.ZipCodeSearch = ZipCodeSearch;
var GetZendeskCategory = /** @class */ (function () {
    function GetZendeskCategory(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/zendesk/categories/" + pathParameter.categoryId;
    }
    return GetZendeskCategory;
}());
exports.GetZendeskCategory = GetZendeskCategory;
var GetZendeskCategorySections = /** @class */ (function () {
    function GetZendeskCategorySections(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/zendesk/categories/" + pathParameter.categoryId + "/sections";
    }
    return GetZendeskCategorySections;
}());
exports.GetZendeskCategorySections = GetZendeskCategorySections;
var GetZendeskSection = /** @class */ (function () {
    function GetZendeskSection(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/zendesk/sections/" + pathParameter.sectionId;
    }
    return GetZendeskSection;
}());
exports.GetZendeskSection = GetZendeskSection;
var GetZendeskSectionArticles = /** @class */ (function () {
    function GetZendeskSectionArticles(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/zendesk/sections/" + pathParameter.sectionId + "/articles";
    }
    return GetZendeskSectionArticles;
}());
exports.GetZendeskSectionArticles = GetZendeskSectionArticles;
var GetZendeskArticles = /** @class */ (function () {
    function GetZendeskArticles(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/zendesk/articles";
    }
    return GetZendeskArticles;
}());
exports.GetZendeskArticles = GetZendeskArticles;
var GetZendeskArticle = /** @class */ (function () {
    function GetZendeskArticle(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/zendesk/articles/" + pathParameter.articleId;
    }
    return GetZendeskArticle;
}());
exports.GetZendeskArticle = GetZendeskArticle;
var SearchZendeskArticles = /** @class */ (function () {
    function SearchZendeskArticles(args) {
        this.method = types_1.HTTPMethod["get"];
        var params = args.params, pathParameter = args.pathParameter;
        this.params = params;
        this.path = "/zendesk/articles/search";
    }
    return SearchZendeskArticles;
}());
exports.SearchZendeskArticles = SearchZendeskArticles;
//# sourceMappingURL=requests.js.map